import { offlineDb } from './offline-db'
import { getInitSnapshot } from './init-snapshot'
import { getOfflineUsers } from './offline-users-store'

export const DEVICE_PROVISION_META_KEY = 'deviceProvision'

/** Meta keys kept on soft logout (provisioning state for field devices). */
export const PRESERVED_META_KEYS = new Set([DEVICE_PROVISION_META_KEY])

/**
 * Ruoli che possono eseguire "Prepara dispositivo" (Admin, OrganizationAdmin, MultiOrganizationAdmin).
 * @param {number | undefined} userType
 * @returns {boolean}
 */
export function canProvisionDevice(userType) {
  return userType === 1 || userType === 2 || userType === 3
}

/**
 * @returns {Promise<{ deviceProvisionedAt?: string, provisionedByRole?: number, provisionedOrganizationIds?: number[], provisionOrganizationIdForConfig?: number | null, lastProvisioningSyncAt?: string } | null>}
 */
export async function getDeviceProvisionMeta() {
  const rec = await offlineDb.meta.get(DEVICE_PROVISION_META_KEY)
  const value = rec?.value
  if (value && typeof value === 'object') {
    return /** @type {{ deviceProvisionedAt?: string, provisionedByRole?: number, provisionedOrganizationIds?: number[], lastProvisioningSyncAt?: string }} */ (
      value
    )
  }
  return null
}

/**
 * @param {{ provisionedByRole?: number, provisionedOrganizationIds?: number[], provisionOrganizationIdForConfig?: number | null }} [options]
 */
export async function markDeviceProvisioned(options = {}) {
  const existing = (await getDeviceProvisionMeta()) ?? {}
  const now = new Date().toISOString()
  await offlineDb.meta.put({
    key: DEVICE_PROVISION_META_KEY,
    value: {
      ...existing,
      deviceProvisionedAt: existing.deviceProvisionedAt ?? now,
      lastProvisioningSyncAt: now,
      provisionedByRole: options.provisionedByRole ?? existing.provisionedByRole,
      provisionedOrganizationIds:
        options.provisionedOrganizationIds ?? existing.provisionedOrganizationIds,
      provisionOrganizationIdForConfig:
        options.provisionOrganizationIdForConfig !== undefined
          ? options.provisionOrganizationIdForConfig
          : existing.provisionOrganizationIdForConfig
    }
  })
}

/**
 * Dispositivo pronto per login operatore offline.
 * @returns {Promise<boolean>}
 */
export async function isDeviceProvisioned() {
  const meta = await getDeviceProvisionMeta()
  if (meta?.deviceProvisionedAt) return true

  const [loginUsers, snapshot] = await Promise.all([getOfflineUsers(), getInitSnapshot()])
  if (loginUsers.length > 0 && snapshot?.init?.configuration) {
    return true
  }
  return false
}
